import { createFileRoute } from '@tanstack/react-router'
import { AlertsScreen } from '@/features/alerts/alerts-screen'

const text = (value: unknown) => (typeof value === 'string' && value !== '' ? value : undefined)

export const Route = createFileRoute('/_authenticated/alerts')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab?: 'stock' | 'all'; type?: string; warehouse?: string; q?: string; page?: number } => ({
    tab: search.tab === 'stock' || search.tab === 'all' ? search.tab : undefined,
    type: text(search.type),
    warehouse: text(search.warehouse),
    q: text(search.q),
    page: Number(search.page ?? 1),
  }),
  component: AlertsScreen,
})
